<template>
  <div id="bdm_system" :class="isFull === 1 ? 'creator_country_agency top_information1' : ' creator_country_agency'">
    <van-nav-bar :title="$t('column.bdm_system_title',{name:role_type_title })" placeholder fixed left-arrow >
        <template #left>
            <img src="../assets/img/bdm/bdm_left.png" alt="" height="20vw" @click="onClickLeft">
        </template>
        <template #right>
          <div style="position: relative; display: inline-block;">
            <img src="../assets/img/bdm/ic_status_im_notify.png" alt="" height="20vw" @click="onClickMessage">
            <van-info :info="bdm_messages_total" v-if="bdm_messages_total"/>
          </div>
        </template>
    </van-nav-bar>
    <van-row>
      <!--  列表    -->
      <van-col span="22" offset="1" class="bdm_system_list">

        <van-col span="22" offset="1" class="bdm_system_list_item" @click="showCenterBtn('agc_center')">
            <img src="../assets/img/bdm/ic_agc.png" alt="">
           {{$t('column.agc_center')}}
        </van-col>
        <van-col span="22" offset="1" class="bdm_system_list_item" @click="jumpUrl('bdm_host_management',0)">
            <img src="../assets/img/bdm/ic_hs.png" alt="">
          {{$t('column.host_management')}}
        </van-col>
         <van-col span="22" offset="1" class="bdm_system_list_item" @click="showInviteHostBtn">
            <img src="../assets/img/bdm/ic_ad_adm.png" alt="">
          {{$t('column.invite_host')}}
        </van-col>
         <van-col span="22" offset="1" class="bdm_system_list_item" @click="showModifyAgcNameBtn()">
            <img src="../assets/img/bdm/share_moment.png" alt="">
            {{$t('column.modify_agc_name')}}
        </van-col>
        <van-col span="22" offset="1" class="bdm_system_list_item" @click="jumpUrl('creator_agency_apply_details',0)">
            <img src="../assets/img/bdm/order_msg_icon.png" alt="">
            {{$t('column.policy')}}
        </van-col>
      </van-col>

      <van-col span="22" offset="1" class="bdm_system_bottom" @click="jumpUrl('bdm_distribute_reward',0)">
         <img src="../assets/img/bdm/ic_dr.png" alt="">
         {{$t('column.distribute_reward')}}
      </van-col>


     
      <van-popup v-model="showModifyAgcName" class="payroll-popup" round>
        <div class="payroll-header">
          <div class="payroll-title">{{$t('column.modify_agc_name')}}</div>
          <div class="payroll-close-btn" @click="showModifyAgcName = false">
            <van-icon name="cross" />
          </div>
        </div>
        <div class="payroll-content">
          <div class="payroll-form-item">
            <input type="text" :placeholder="$t('column.Agent_name')" class="payroll-input-field" v-model="AgentName" />
          </div>
          <button class="payroll-confirm-btn" :class="{ 'disabled': !AgentName }" :disabled="!!(!AgentName)" @click="confirmModifyAgcName">{{$t('column.confirm_request')}}</button>
        </div>
      </van-popup>

      <van-popup v-model="showInviteHost" class="invite-host-popup" round>
        <div class="invite-host-header">
          <span class="invite-host-title">{{ $t('column.invite_host') }}</span>
          <div class="invite-host-close-btn" @click="showInviteHost = false">
            <van-icon name="cross" />
          </div>
        </div>
        <div class="invite-host-content">
          <div class="invite-host-form-item">
            <div class="invite-host-label">{{$t('column.user_id') || 'User ID'}}</div>
            <input type="text" :placeholder="$t('column.enter_user_id')" class="invite-host-input-field" v-model="inviterId" />
          </div>
          <div class="invite-host-form-item">
            <div class="invite-host-label">{{$t('column.host_code') || 'Host Code'}}</div>
            <input type="text" :placeholder="$t('column.enter_host_code')" class="invite-host-input-field" v-model="hostCode" />
            <van-button size="small" round color="#ff6b9e" class="get-btn" :disabled="countdown > 0" @click="getCode">{{ countdown > 0 ? countdown + 's' : $t('column.get_code') }}</van-button>
          </div>

          <button class="invite-host-confirm-btn" :class="{ 'disabled': !inviterId || !hostCode }" :disabled="!!(!inviterId || !hostCode)" @click="confirmInviteHost">{{$t('btn.confirm')}}</button>
        </div>
      </van-popup>

      <van-overlay :show="loading" z-index="2003">
        <van-loading type="spinner" class="loading_overlay"/>
      </van-overlay>
    </van-row>
  </div>
</template>
<script>
import '@/assets/css/style.css'
import axios from 'axios'
import { Toast } from 'vant'

export default {
  data:function() {
    return {
      loading: false,
      finished: false,
      showModifyAgcName: false,
      showInviteHost: false,
      inviterId: '',
      verificationCode: '',
      hostCode: '',
      roleType: 0,
      AgentName: '',    
      bdm_messages_total: 0,
      role_type_title:'AGC',
      countdown: 0,
      timer: null,
      isFull: 0, // is_full=1 全屏显示信号栏 0 非全屏显示信号栏
    }
  },
  created() {
    this.isFull = this.$route.query.is_full == 1 ? 1 : 0 // is_full=1 显示信号栏
    this.get_list()
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },
  methods: {
    onClickLeft() {
      // 拦截关闭h5
      window.location.href="bogolive://exit"
    },
    jumpUrl(name,type){
       this.$router.push({
          path: '/' + name,
          query: {
            type: type,
            token: this.$route.query.token,
            is_full: this.isFull,
            is_navigation_bar: 1,
          }
        })
    },
    onClickMessage(){
      this.$router.push({
        path: '/bdm_message',
        query: {
          token: this.$route.query.token,
          is_full: this.isFull,
          is_navigation_bar: 1,
        }
      })
    },
    showCenterBtn(centerType) {
      if (centerType == 'agc_center'){
        this.$router.push({
          path: '/agc_center',
          query: {
            center_type: centerType,
            token: this.$route.query.token,
            is_full: this.isFull,
            is_navigation_bar: 1,
          }
        })
      }else{
        this.$router.push({
          path: '/bdm_center',
          query: {
            center_type: centerType,
            token: this.$route.query.token,
            is_full: this.isFull,
            is_navigation_bar: 1,
          }
        })
      }
    },
    getCode() {
      if (this.countdown > 0) return
      this.loading = true
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=system_bdm&act=get_verify_code", {
        params : {
            to_user_id: this.inviterId,
            token: token,
            role_type: 3
        }
      }).then(res =>{
        this.loading = false
        Toast(res.data.error)
        if (res.data.status === 1) {
          this.countdown = 60
          this.timer = setInterval(() => {
            this.countdown--
            if (this.countdown <= 0) {
              clearInterval(this.timer)
              this.timer = null
            }
          }, 1000)
        }
      })
    },
    Jump_intercept(item) {
      // 拦截返回app
      window.location.href="live://live?action=recharge&id="+ item.id
    },

    showModifyAgcNameBtn(){
      this.showModifyAgcName = true
    },
    confirmModifyAgcName(){
      this.loading = true
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=system_bdm&act=save_agc_name", {
        params : {
            agc_name: this.AgentName,
            token: token,
        }
      }).then(res =>{
        this.loading = false
        Toast(res.data.error)
        if (res.data.status === 1) {
            this.showModifyAgcName = false
            this.get_list()
        }
      }).catch(err => {
        this.loading = false
      })
    },
    showInviteHostBtn() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      this.countdown = 0
      this.inviterId = ''
      this.hostCode = ''
      this.showInviteHost = true
    },
    confirmInviteHost() {
      this.loading = true
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=system_bdm&act=invite_host", {
        params : {
            to_user_id: this.inviterId,
            verify_code: this.hostCode,
            token: token,
        }
      }).then(res =>{
        this.loading = false
        Toast(res.data.error)
        if (res.data.status === 1) {
            this.showInviteHost = false
            this.get_list()
        }
      }).catch(err => {
        this.loading = false
      })
    },
    get_list(){
      this.loading = true
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=system_bdm&act=get_agc_list",{ params:{token: token }}).then(res =>{
        console.log(res)
        // 加载状态结束
          this.loading = false
        if(res.data.status===1){
          this.AgentName = res.data.data.agc_title
          this.bdm_messages_total = res.data.data.bdm_messages_total
          this.finished = true
          this.loading = false
        }else{
          // 数据全部加载完成
          this.finished = true
          Toast.fail(res.data.error);
        }
      })
    }
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/bdm_agc_system.vue